import { HttpClient } from '@angular/common/http'

import { fromReadableStream } from '@rxjs-ninja/rxjs-utility'

import { Observable, map, switchMap } from 'rxjs'
import { fromFetch } from 'rxjs/fetch'

import { addParams } from '@flowx/shared/utils'

export interface PaginationQueryParams {
  page?: number
  size?: number
  sort?: (string | number)[]
  direction?: string
  query?: string
  keyword?: string
  filterKey?: string
  excludeSystemResources?: boolean
}

export interface IError {
  defaultMessage: string
  entityName: string
  errorKey: string
  message: string
  params: string
  status: number
  title: string
  type: string
}

export const DEFAULT_PAGINATION_PARAMS = { page: 0, size: 20 }

export class ApiHttpService {
  protected addParams = addParams

  constructor(
    private baseUrl: string,
    private http: HttpClient
  ) {}

  protected get = (path: string, options?: any): Observable<any> =>
    this.http.get(this.buildUrl(path), options)
  protected head = (path: string, options?: any): Observable<any> =>
    this.http.head(this.buildUrl(path), options)

  protected post = (path: string, data: any, options?: any): Observable<any> =>
    this.http.post(this.buildUrl(path), data, options)

  protected put = (path: string, data: any, options?: any): Observable<any> =>
    this.http.put(this.buildUrl(path), data, options)

  protected patch = (path: string, data: any, options?: any): Observable<any> =>
    this.http.patch(this.buildUrl(path), data, options)

  protected delete = (path: string, options?: any): Observable<any> =>
    this.http.delete(this.buildUrl(path), options)

  protected stream = (path: string, data: any, options?: any): Observable<any> => {
    const token = localStorage.getItem('access_token')
    const signal: AbortController = new AbortController()

    return fromFetch(this.buildUrl(path), {
      method: 'POST',
      body: JSON.stringify(data),
      ...options,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    }).pipe(
      switchMap((response: Response) => {
        if (response.status >= 400) {
          throw response
        } else {
          return fromReadableStream(response.body, signal.signal)
        }
      }),
      map((uint8array: any) => new TextDecoder().decode(uint8array))
    )
  }

  protected buildUrl(path: string): string {
    if (path) {
      return `${this.baseUrl}/${path}`
    } else {
      return `${this.baseUrl}`
    }
  }
}
